import { useFormContext } from 'react-hook-form'
import type { ProductCheckboxGroupValues } from '../../ProductCheckboxGroup'
import { SignupInterestsEnum } from 'gql/types'

export const useProductCheckboxGroupOptions = () => {
  const form = useFormContext<ProductCheckboxGroupValues>()
  const value = form.watch('interestedIn')

  const productOptions = [
    {
      key: SignupInterestsEnum.BILL_PAY,
      fieldName: 'billPay',
      visible: typeof value.billPay === 'boolean',
      checked: value.billPay,
      titleKey: 'onboarding::product::multiOptions::billPay::title',
    },
    {
      key: SignupInterestsEnum.WORKING_CAPITAL,
      fieldName: 'workingCapital',
      visible: typeof value.workingCapital === 'boolean',
      checked: value.workingCapital,
      titleKey: 'onboarding::product::multiOptions::ept::title',
    },
    {
      key: SignupInterestsEnum.PURCHASING,
      visible: true,
      fieldName: 'purchasing',
      checked: value.purchasing,
      titleKey: 'onboarding::product::multiOptions::po::title',
    },
    {
      key: SignupInterestsEnum.LANDED_COSTS,
      fieldName: 'landedCosts',
      visible: typeof value.landedCosts === 'boolean',
      checked: value.landedCosts,
      titleKey: 'onboarding::product::multiOptions::landedCosts::title',
    },
  ] as const

  return {
    productOptions,
  }
}
